import { render } from "./KtpPreviewModal.vue?vue&type=template&id=44721968&scoped=true"
import script from "./KtpPreviewModal.vue?vue&type=script&lang=js"
export * from "./KtpPreviewModal.vue?vue&type=script&lang=js"

import "./KtpPreviewModal.vue?vue&type=style&index=0&id=44721968&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44721968"]])

export default __exports__